import React, { Component } from 'react'
import Styled from 'styled-components'

import Content from 'components/Content'
import Form from 'components/Form'
import FormGroup from 'components/FormGroup'
import FormErrors from 'components/FormErrors'
import Input from 'components/Input'
import Button from 'components/Button'

const ContentExtended = Styled(Content)`
  padding: 3rem 0;
`

class ProjectCreatorUI extends Component {
  componentDidMount() {
    this.name.focus()
  }

  handleNameBlur = () => {
    if (!this.props.urlValue.trim()) {
      const url = this.props.nameValue
        .trim()
        .replace(/[^A-Za-z0-9_-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^[^A-Za-z0-9]/g, '')
        .toLowerCase()

      this.props.onUrlChange(url)
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.onSubmit()
  }

  render() {
    const {
      isCreating,

      nameValue,
      nameErrors,
      onNameChange,

      urlValue,
      urlErrors,
      onUrlChange,

      generalErrors
    } = this.props

    return (
      <ContentExtended>
        <Form onSubmit={this.handleSubmit}>
          <FormGroup>
            <Input
              type="text"
              name="name"
              value={nameValue}
              onChange={e => onNameChange(e.target.value)}
              onBlur={this.handleNameBlur}
              placeholder="My awesome project"
              autoComplete="off"
              ref={(node) => { this.name = node }}
            />

            <FormErrors
              errors={nameErrors}
            />
          </FormGroup>

          <FormGroup>
            <Input
              type="text"
              name="url"
              value={urlValue}
              onChange={e => onUrlChange(e.target.value)}
              placeholder="my-awsome-project"
              autoComplete="off"
            />

            <FormErrors
              errors={urlErrors}
            />
          </FormGroup>

          <FormGroup>
            <Button type="submit" expand loading={isCreating}>
              Create project
            </Button>

            <FormErrors
              errors={generalErrors}
            />
          </FormGroup>
        </Form>
      </ContentExtended>
    )
  }
}

export default ProjectCreatorUI



// WEBPACK FOOTER //
// ./src/components/ProjectCreatorUI/index.js